import { Box, Paper, Typography, Button, Stack } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import WifiOffIcon from '@mui/icons-material/WifiOff';

/**
 * The page's code could not be downloaded. Either the app was updated since
 * this tab opened (the old file is gone — a reload fetches the new one), or
 * the connection dropped. Neither is a bug in the page, so no stack trace and
 * no "send to support": just the one action that fixes it. "Retry" has to be
 * a full reload — React.lazy remembers the failed download.
 */
export function StaleVersionCard() {
  const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
  return (
    <Box sx={{ maxWidth: 560, mx: 'auto', mt: 4 }}>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Stack spacing={2} alignItems="flex-start">
          <Stack direction="row" spacing={1.5} alignItems="center">
            {offline
              ? <WifiOffIcon color="warning" />
              : <SystemUpdateAltIcon color="primary" />}
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              {offline ? 'You appear to be offline' : 'A new version of Payroll is available'}
            </Typography>
          </Stack>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {offline
              ? 'This page could not be loaded because the connection dropped. '
                + 'Check your network, then try again.'
              : 'The app was updated since this tab was opened, so this page needs '
                + 'a quick reload. Anything you have already saved is safe.'}
          </Typography>
          <Button variant="contained" startIcon={<RefreshIcon />}
            onClick={() => window.location.reload()}>
            {offline ? 'Try again' : 'Reload now'}
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
